import type { HTMLInputTypeAttribute } from 'react';

/** API / form field name for Iraqi mobile (E.164 `+964…` after `FieldPhone` blur). */
export const B2B_REGISTRATION_PHONE_FIELD_NAME = 'phoneNumber' as const;

/** Required when the location section is shown; use with {@link FieldSelect}. */
export const B2B_REGISTRATION_CITY_FIELD_NAME = 'city' as const;

/** Optional; native `YYYY-MM-DD` from {@link FieldDate}. */
export const B2B_REGISTRATION_EVENT_DATE_FIELD_NAME = 'eventDate' as const;

/** Optional; native `HH:mm` from {@link FieldTime}. */
export const B2B_REGISTRATION_EVENT_TIME_FIELD_NAME = 'eventTime' as const;

/** API field: previous hosting experience (`hasOrganizedBefore`). */
export const B2B_REGISTRATION_HAS_ORGANIZED_BEFORE_FIELD_NAME = 'hasOrganizedBefore' as const;

/** API field: venue confirmation flag (`isVenueConfirmed`). */
export const B2B_REGISTRATION_VENUE_CONFIRMED_FIELD_NAME = 'isVenueConfirmed' as const;

export const B2B_REGISTRATION_FULL_NAME_FIELD_NAME = 'fullName' as const;

export const B2B_REGISTRATION_COMPANY_OR_ORGANIZATION_FIELD_NAME = 'companyOrOrganization' as const;

export const B2B_REGISTRATION_EMAIL_FIELD_NAME = 'email' as const;

export const B2B_REGISTRATION_WEBSITE_OR_SOCIAL_MEDIA_FIELD_NAME = 'websiteOrSocialMedia' as const;

export const B2B_REGISTRATION_EVENT_NAME_FIELD_NAME = 'eventName' as const;

export const B2B_REGISTRATION_DESCRIPTION_FIELD_NAME = 'description' as const;

export const B2B_REGISTRATION_EVENT_VENUE_FIELD_NAME = 'eventVenue' as const;

export const B2B_REGISTRATION_PREVIOUS_EVENTS_FIELD_NAME = 'previousEvents' as const;

export type B2bRegistrationTextFieldKey =
  | 'fullName'
  | 'companyOrOrganization'
  | 'email'
  | 'eventName'
  | 'websiteOrSocialMedia'
  | 'description'
  | 'previousEvents';

/** Keys with `b2b.registration.field.<key>.placeholder` in locale files. */
export type B2bRegistrationPlaceholderKey =
  | B2bRegistrationTextFieldKey
  | 'eventVenue'
  | 'eventDate'
  | 'eventTime';

export type B2bRegistrationFieldDef = {
  key: B2bRegistrationTextFieldKey;
  kind: 'text' | 'textarea';
  inputType?: HTMLInputTypeAttribute;
};

export const B2B_REGISTRATION_FIELD_DEFS: readonly B2bRegistrationFieldDef[] = [
  { key: 'fullName', kind: 'text' },
  { key: 'companyOrOrganization', kind: 'text' },
  { key: 'email', kind: 'text', inputType: 'email' },
  { key: 'eventName', kind: 'text' },
  { key: 'websiteOrSocialMedia', kind: 'text', inputType: 'url' },
  { key: 'description', kind: 'textarea' },
  { key: 'previousEvents', kind: 'textarea' },
] as const;

export const b2bRegistrationFieldLabelMessageId = (key: B2bRegistrationTextFieldKey) =>
  `b2b.registration.field.${key}.label` as const;

export const b2bRegistrationFieldPlaceholderMessageId = (key: B2bRegistrationPlaceholderKey) =>
  `b2b.registration.field.${key}.placeholder` as const;
